export const SET_INFERENCE_DATA = 'SET_INFERENCE_DATA';

/* global InferenceData, SetInferenceAction */

export const setInferenceData = (data: InferenceData): SetInferenceAction => ({
  type: SET_INFERENCE_DATA,
  payload: data,
});
